import SelectComponent from '@componentes/select/select.component';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Badge,
} from 'reactstrap';
import IntlMessage from '../../../helpers/intlMessage';
import './recolhimento.styles.css';

const RecolhimentoMultiPage = (props) => {
  const intl = useIntl();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  return (
  <div className='mv-rastreabilidade'>
    <Row>
      <Col>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.sample.userOf"/>:</Label>
              <SelectComponent
                options={props.usuarios}
                onChange={(e) =>
                  props.updateStateGenerico('usuarioRecebimento', e)
                }
                value={props.usuarioRecebimento}
                placeholder={translate("dashboards.examDetail.user")}
                innerRef={props.usuarioRecebimentoRef}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.sample.processOf"/>:</Label>
              <SelectComponent
                options={props.processos}
                onChange={(e) =>
                  props.updateStateGenerico('processoRecebimento', e)
                }
                value={props.processoRecebimento}
                placeholder={translate("dashboards.sample.process")}
                innerRef={props.processoRecebimentoRef}
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
    </Row>
    <br />
    <Row>
      <Col>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.sample.userFor"/>:</Label>
              <SelectComponent
                options={props.usuarios}
                onChange={(e) =>
                  props.updateStateGenerico('usuarioDelegacao', e)
                }
                value={props.usuarioDelegacao}
                placeholder={translate("dashboards.sample.users")}
                innerRef={props.usuarioDelegacaoRef}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.sample.processFor"/>:</Label>
              <SelectComponent
                options={props.processos}
                onChange={(e) =>
                  props.updateStateGenerico('processoDelegacao', e)
                }
                value={props.processoDelegacao}
                placeholder={translate("dashboards.sample.process")}
                innerRef={props.processoDelegacaoRef}
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
    </Row>
    <br />
    <Row>
      <Col>
        <Row>
          <Col>
            <Label><IntlMessage id="dashboards.disposalMaterials.table.exams"/>:</Label>
            <InputGroup>
              <Input
                className='listagemNumeroExames'
                placeholder={`${intl.formatMessage({id: 'dashboards.sample.searchByExamNumber'})}`}
                onKeyPress={props.addListagemNumeroExames}
                innerRef={props.listaRef}
              />
            </InputGroup>
          </Col>
        </Row>
      </Col>
    </Row>
    <Button
      color='primary'
      className='buttonConfirma'
      onClick={props.confirma}
      disabled={props.listagemNumeroExames.length <= 0}
    >
      <IntlMessage id="dashboards.disposalMaterials.modal.confirm"/>
    </Button>{' '}
    {props.listagemNumeroExames.length > 0 && (
      <Button
        color='danger'
        className='buttonLimpar'
        onClick={props.limparListagemNumeroExames}
      >
        <IntlMessage id="dashboards.sample.clearSelected"/>
      </Button>
    )}
    {props.listagemNumeroExames.map((item, key) => {
      return (
        <Badge
          key={key}
          style={{ marginRight: '8px', fontSize: '13px' }}
          color='primary'
          className='badgeExames'
        >
          {item}
          <Button
            color='link'
            item={item}
            onClick={props.removeListagemNumeroExames}
          >
            <i className='far fa-trash-alt iconRemover'></i>
          </Button>
        </Badge>
      );
    })}
  </div>
)};

export default RecolhimentoMultiPage;



// WEBPACK FOOTER //
// ./src/app/common/recolhimento/recolhimento.multi.page.js